import { Box, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Button, Select, } from '@chakra-ui/react';
import { useEffect, useState, useRef } from 'react';
import MyDiv from './personalDetails.style';
import { PersonalDetailModel } from "../../../../../models/personalDetails";
import { CustomToast } from '../../../../../components';
import { EmployeePersonalInfo } from './modal';
import { useFetch } from '../../../../../hooks/useFetch';
import AutoCompleteInput from '../../../../../components/AutoCompleteInput/AutoCompleteInput';
import IdentityDetails from './identityDetails';
import AddressDetails from './addressDetails';
import EmergencyContact from './emergencyContact';
import ReferenceDetails from './referenceDetails';
import Hierarchy from './hierarchy';
import BasicDetails from './basicDetails';
import MaritalStatus from './maritalstatus';
import HeirarchyCheck from './hierarchyCheck'
import ContactDetails from './contactDetails ';

interface props {
  employeeId: number | null
}
export interface Option {
  id: number;
  reference: string;
}

const PersonalDetails = ({ employeeId }: props) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [editingSection, setEditingSection] = useState<PersonalDetailModel | null>(null);
  const [personalDetail, setPersonalDetail] = useState<EmployeePersonalInfo>()
  const [loading, setLoading] = useState(false);
  const [managerOptions, setManagerOptions] = useState<{ label: string; id: number }[]>([]);
  const [teamLeadOptions, setTeamLeadOptions] = useState<{ label: string; id: number }[]>([]);
  const [selectedManagerId, setSelectedManagerId] = useState<number | null>(null);
  const [selectedTeamLeadId, setSelectedTeamLeadId] = useState<number | null>(null);
  const [refOption, setRefOption] = useState<Option[]>([]);
  const [selectedReferenceId, setSelectedReferenceId] = useState<number | null>(null);


  const managerTimeout = useRef<any>(null);
  const teamLeadTimeout = useRef<any>(null);

  const handleEditClick = (section: PersonalDetailModel) => {
    setEditingSection(section);
    setDrawerOpen(true);
    setSelectedManagerId(null);
    setSelectedTeamLeadId(null);

    if (section.title === "Reference Details") {
      setSelectedReferenceId(personalDetail?.reference_id ?? null);
    }
  };


  async function loadPersonalDetails() {
    const response = await fetchApi('Hrlense_Employee/personalDetail', "GET", null, `employeeId=${employeeId}`, "");
    if (response) {
      setPersonalDetail(response);
    }
  }


  async function loadReferenceDropdown() {
    const response = await fetchApi('DropDown/reference', "GET", null, ``, "");
    if (response) {
      setRefOption(response);
    }
  }


  useEffect(() => {
    if (employeeId) {
      loadPersonalDetails()
      loadReferenceDropdown()
    }
  }, [employeeId])

  const handleManagerChange = (value: string) => {
    if (managerTimeout.current) clearTimeout(managerTimeout.current);

    setEditingSection((prev) => {
      if (!prev) return prev;
      const updatedData = prev.data.map((field: any) =>
        field.key === "manager" ? { ...field, value } : field
      );
      return { ...prev, data: updatedData };
    });

    managerTimeout.current = setTimeout(async () => {
      if (value.length > 1) {
        setLoading(true);
        const res = await fetchApi("Hrlense_Employee/EmployeeList", "GET", null, `filter=${value}&assignedCompany=1`, "");
        if (res) {
          setManagerOptions(
            res.map((emp: any) => ({
              id: emp.employeeID,
              label: emp.emp_Name,
            }))
          );
        }
        setLoading(false);
      }
    }, 500);
  };

  const handleTeamLeadChange = (value: string) => {
    if (teamLeadTimeout.current) clearTimeout(teamLeadTimeout.current);

    setEditingSection((prev) => {
      if (!prev) return prev;
      const updatedData = prev.data.map((field: any) =>
        field.key === "teamLead" ? { ...field, value } : field
      );
      return { ...prev, data: updatedData };
    });

    teamLeadTimeout.current = setTimeout(async () => {
      if (value.length > 1) {
        setLoading(true);
        const res = await fetchApi("Hrlense_Employee/EmployeeList", "GET", null, `filter=${value}&assignedCompany=1`, "");
        if (res) {
          setTeamLeadOptions(
            res.map((emp: any) => ({
              id: emp.employeeID,
              label: emp.emp_Name,
            }))
          );
        }
        setLoading(false);
      }
    }, 500);
  };

  const handleSubmit = async () => {
    if (!editingSection || employeeId === null) return;

    const data: { [key: string]: string | number | undefined } = { empId: employeeId };

    editingSection.data.forEach((d) => {
      const key = d.key;
      const value = d.value;

      if (key === "manager" && selectedManagerId) {
        data["managerId"] = selectedManagerId;
      } else if (key === "teamLead" && selectedTeamLeadId) {
        data["teamLeadId"] = selectedTeamLeadId;
      }
      else if (key === "reference" && selectedReferenceId) {
        data["Reference"] = selectedReferenceId;
      }
      else {
        if (key) data[key] = value;
      }
    });

    const response = await fetchApi(`Hrlense_Employee/personalDetail/${employeeId}`, "PUT", data, null, "Personal Detail Updated");
    if (response) {
      setDrawerOpen(false);
      loadPersonalDetails();
    }
  };

  return (
    <MyDiv>
      <IdentityDetails employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />
      <ContactDetails employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />
      <AddressDetails employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />
      <ReferenceDetails employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />
      <EmergencyContact employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />
      {/* <Hierarchy employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} /> */}
      <BasicDetails employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />
      <MaritalStatus employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />
      <HeirarchyCheck employeeId={employeeId} personalDetail={personalDetail} reload={loadPersonalDetails} />

      {drawerOpen && (
        <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="md">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Update {editingSection?.title}</DrawerHeader>

            <DrawerBody pb="80px">
              {editingSection?.data?.map((item: any, index: number) => {
                if (item.key === "referred_By" && selectedReferenceId === 1) {
                  return null;
                }

                return (
                  <FormControl key={index} mb={4}>
                    <FormLabel>{item.label}</FormLabel>

                    {item.key === "reference" ? (
                      <FormControl key={index} mb={4}>
                        <Select
                          value={selectedReferenceId ?? ""}
                          onChange={(e) => {
                            const id = Number(e.target.value);
                            const label = refOption.find(r => r.id === id)?.reference || "";

                            setSelectedReferenceId(id);

                            setEditingSection((prev) => {
                              if (!prev) return prev;
                              const updatedData = prev.data.map((field: any) =>
                                field.key === item.key ? { ...field, value: label } : field
                              );
                              return { ...prev, data: updatedData };
                            });
                          }}
                        >
                          <option value="">-- Select Reference --</option>
                          {refOption.map((ref) => (
                            <option key={ref.id} value={ref.id}>
                              {ref.reference}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    ) : item.key === "manager" ? (
                      <AutoCompleteInput
                        placeholder="Search Manager..."
                        value={item.value ?? ""}
                        onChange={handleManagerChange}
                        options={managerOptions}
                        loading={loading}
                        onSelect={(label, id) => {
                          setSelectedManagerId(id);
                          setEditingSection((prev) => {
                            if (!prev) return prev;
                            const updatedData = prev.data.map((field: any) =>
                              field.key === item.key ? { ...field, value: label } : field
                            );
                            return { ...prev, data: updatedData };
                          });
                        }}
                      />
                    ) : item.key === "teamLead" ? (
                      <AutoCompleteInput
                        placeholder="Search Team Lead..."
                        value={item.value ?? ""}
                        onChange={handleTeamLeadChange}
                        options={teamLeadOptions}
                        loading={loading}
                        onSelect={(label, id) => {
                          setSelectedTeamLeadId(id);
                          setEditingSection((prev) => {
                            if (!prev) return prev;
                            const updatedData = prev.data.map((field: any) =>
                              field.key === item.key ? { ...field, value: label } : field
                            );
                            return { ...prev, data: updatedData };
                          });
                        }}
                      />
                    ) : (
                      <Input
                        name={item.key}
                        value={item.value}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          if (name === "aadhar_Number" && (!/^\d*$/.test(value))) {
                            return;
                          }
                          setEditingSection((prev) => {
                            if (!prev) return prev;
                            const updatedData = prev.data.map((field: any) =>
                              field.key === name ? { ...field, value } : field
                            );
                            return { ...prev, data: updatedData };
                          });
                        }}
                      />
                    )}
                  </FormControl>
                );
              })}
            </DrawerBody>

            <Box position="fixed" bottom="24px" right="24px" px={4} py={2}>
              <Button className='btn_theme btn_theme:hover' onClick={handleSubmit}>Update Details</Button>
            </Box>
          </DrawerContent>
        </Drawer>
      )}
    </MyDiv>
  );
};

export default PersonalDetails;